import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-link-used-error',
  templateUrl: './link-used-error.component.html',
  styleUrls: ['./link-used-error.component.scss'],
})
export class LinkUsedErrorComponent {
  @Input() onBackToSignIn!: () => void;

  constructor() {}

  backToSignIn() {
    window.history.pushState({}, document.title, window.location.pathname);
    this.onBackToSignIn();
  }
}
